<!--
    `!invalidURL` nestes dois: eles vivem FORA do container de scroll e eram os
    únicos do arquivo sem a guarda que o corpo, o rodapé e o `<app-not-found>` já
    usam. Sem restaurante o `BalanceCashbackComponent.ngOnInit` chama
    `cashbackService.getCashbackBalance()`, que desreferencia
    `restaurant.info.id` e estoura (Sentry PEDIRDELIVERY-P). Além do erro, é
    chrome de loja renderizado por cima de uma tela que diz "não encontrado".
-->
<!-- ngSkipHydration: carrinho e saldo vêm do APARELHO (localStorage, login), e o HTML
     pré-renderizado é o mesmo para todo cliente. O cliente renderiza os dois do zero. -->
<cart *ngIf="!invalidURL" ngSkipHydration></cart>
<balance-cashback *ngIf="!invalidURL" ngSkipHydration></balance-cashback>
<!-- ion-content → div de scroll nativo (mp): o scroll/sticky é gerido por listener
     nativo no ngAfterViewInit; content vira adaptador (getScrollElement/scrollToTop/scrollToPoint). -->
<div #scrollContainer class="menu-scroll-container" [class.menu-content--new-home]="isNewHomePedirDelivery">
    <!-- "Não deu tempo" não é "não existe" — ver menu.page.ts. Sem este bloco,
         quem estava só numa rede ruim lia "loja não encontrada" e ia embora. -->
    <app-not-found *ngIf="invalidURL && !cargaExpirou"></app-not-found>
    <div *ngIf="cargaExpirou" class="carga-expirou">
        <p class="carga-expirou__texto">{{ 'Please reload the page.' | translate }}</p>
        <button type="button" class="carga-expirou__btn" (click)="recarregar()">
            {{ 'Reload' | translate }}
        </button>
    </div>
    <div *ngIf="loaded && !invalidURL" class="menu" [class.menu--blocked]="restaurantIsBlocked">
        <div *ngIf="false" class="insta-ios-banner">
            <div class="mp-grid">
              <div class="mp-row insta-ios-row">

                <div class="mp-col mp-col-10 insta-ios-left">

                  <h3 class="insta-ios-title">
                    <mp-icon name="alert-circle-outline"></mp-icon>
                    Você está usando o navegador do Instagram no iOS
                  </h3>

                  <p class="insta-ios-subtitle">
                    Sua experiência pode ser limitada. Para melhor uso, siga as instruções abaixo:
                  </p>

                  <ol class="insta-ios-steps">
                    <li>
                      Clique no ícone
                      <b><mp-icon name="ellipsis-horizontal"></mp-icon></b>
                      no canto superior direito do navegador do Instagram
                    </li>
                    <li>Selecione <b>"Abrir no navegador externo"</b></li>
                  </ol>

                </div>

                <div class="mp-col mp-col-2 insta-ios-right">
                  <mp-icon name="arrow-up-outline" class="insta-ios-corner-icon"></mp-icon>
                </div>

              </div>
            </div>
            <div class="insta-ios-close-container">
              <button class="mp-button mp-button--clear mp-button--small insta-ios-close-btn" (click)="closeInstagramIosBanner()">
                Fechar
              </button>
            </div>
          </div>
        <app-header [restaurant]="restaurant"></app-header>

        <div *ngIf="isNewHomePedirDelivery && highlightImages.length > 0" class="featured-carousel" appDragScroll>
          <!-- Só a 1ª foto recebe o endereço de saída; as outras recebem quando ela chega (ver
               `liberarDestaques`). Não dá para usar loading="lazy": o Chrome adianta imagem lazy a até
               ~1.250px da tela, e o carrossel inteiro cabe nisso — as cinco saíam juntas, dividiam a
               banda e a 1ª chegava por ÚLTIMO (medido em 18/09/2026). O <span> já reserva 160×160,
               então as que esperam não fazem nada pular. A 1ª tem prioridade quando não há capa.

               QUANDO HÁ CAPA, A 1ª É `low` DE PROPÓSITO. A capa é o maior elemento (o LCP), e o
               Chrome promove a `high` toda imagem visível — a 1ª do carrossel também, e aí ela
               (35 KB) disputava a banda com a capa (15 KB). Com `low` explícito o Chrome não
               promove, e a simulação de 4G do PageSpeed a tira da conta do LCP.
               `alt=""`: o destaque não tem texto no cadastro (só a imagem). -->
          <span *ngFor="let image of highlightImages; let i = index" style="position: relative">
            <img draggable="false" class="highlight-image"
                 [attr.src]="i === 0 || destaquesLiberados ? urlDoDestaque(image.image) : null"
                 [attr.data-original]="originalDoDestaque(image.image)"
                 alt=""
                 [attr.fetchpriority]="i !== 0 ? null : restaurant.info.cover_pic ? 'low' : 'high'"
                 (load)="i === 0 && liberarDestaques()"
                 (error)="i === 0 && liberarDestaques()"/>
          </span>
        </div>

        <div *ngIf="restaurantIsBlocked" class="menu__blocked-state container text-center" style="width: 100%;">
            <mp-icon name="alert-circle" style="font-size: 40px; margin-top: 70px; color: #AAA;"></mp-icon>
            <h4 class="mt-0" style="color: #AAA; font-size: 20px; font-weight: 600;" translate>Menu currently unavailable</h4>
        </div>

        <div *ngIf="!restaurantIsBlocked">
            <!-- Recomendados saem dos últimos pedidos DESTE aparelho: nunca no HTML do servidor. -->
            <show-recommended-products 
                ngSkipHydration
                *ngIf="recommendedProducts.length > 0"
                [recommendedProducts]="recommendedProducts"
                [restaurant]="restaurant"
            ></show-recommended-products>
         
            <!-- Nova versão: barra sticky + pills/select + input na barra ou abaixo -->
            <ng-container *ngIf="isNewHomePedirDelivery">
                <div #stickyBar class="menu-sticky-bar" [class.menu-sticky-bar--sticky]="isSticky">
                    <img *ngIf="isSticky && avatarDaLoja" class="menu-sticky-avatar" [src]="avatarDaLoja" [attr.data-original]="restaurantProfilePicUrl" [alt]="restaurant.info.name">
                    <category-nav
                        [categories]="categories"
                        [itemsToHide]="itemsToHide"
                        [sectionOrder]="menuSectionOrder"
                        [comboCategoryName]="restaurant.info.combo_category_name"
                        [pizzaCategoryName]="restaurant.info.pizza_category_name"
                        [stickyMode]="isSticky"
                        [activeCategoryValue]="currentCategoryValue"
                        [isNewHomePedirDelivery]="true"
                        (scrollToCategory)="scrollToElement($event)"
                    ></category-nav>
                    <div *ngIf="isSticky" class="menu-search-item" (click)="openSearchModal()">
                        <svg class="menu-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                        <span class="menu-search-placeholder">{{ 'Search' | translate }}</span>
                    </div>
                </div>
                <div *ngIf="isSticky" class="menu-sticky-spacer" aria-hidden="true"></div>
                <div *ngIf="!isSticky" class="menu-search-below">
                    <div class="menu-search-item" (click)="openSearchModal()">
                        <svg class="menu-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                        <span class="menu-search-placeholder">{{ 'Search' | translate }}</span>
                    </div>
                </div>
            </ng-container>

            <!-- Versão antiga (master): ion-segment sticky nativo do Ionic + ion-item search -->
            <!-- TODO: remove this when new pedir delivery is on 100% of the clients -->
            <ng-container *ngIf="!isNewHomePedirDelivery">
                <category-nav
                    [categories]="categories"
                    [itemsToHide]="itemsToHide"
                    [sectionOrder]="menuSectionOrder"
                    [comboCategoryName]="restaurant.info.combo_category_name"
                    [pizzaCategoryName]="restaurant.info.pizza_category_name"
                    [activeCategoryValue]="currentCategoryValue"
                    (scrollToCategory)="scrollToElement($event)"
                ></category-nav>
                <mp-floating-label class="menu-search">
                    <span mpFloatingLabelText translate><mp-icon name="search-outline"></mp-icon> Search</span>
                    <input #ionicInput class="mp-input" enterkeyhint="search" type="search" inputmode="search" [attr.aria-label]="'Search' | translate" (input)="onNewSearchInput($event)">
                </mp-floating-label>
            </ng-container>

            <app-menu-list [menu]="isNewHomePedirDelivery ? restaurant?.menu : (searchResults || restaurant?.menu)" [info]="restaurant.info" (listReady)="onListReady($event)"></app-menu-list>
        </div>
    </div>

    <footer class="footer-MP" *ngIf="!invalidURL">
        <div class="footer-content">
            <!-- #footerBanner: alvo do IntersectionObserver que produz o DENOMINADOR
                 (ClientMpBannerViewed). É o bloco inteiro do banner — texto, logo e
                 chamada —, não só a logo: "o banner apareceu" é sobre a peça que a
                 pessoa vê, e observar um dos dois links daria dois denominadores
                 diferentes para a mesma impressão. -->
            <div class="footer-section" #footerBanner>
                <p class="developed-by" translate>Developed by</p>
                
                <a [href]="footerLinkLogo" target="_blank" rel="noopener" class="logo-link"
                   data-cy="mpBannerLogo" (click)="onFooterBannerClick('logo', $event)">
                    <img class="MP-logo" src="assets/icon/mp-footer-horizontal.png" width="300" height="57" alt="Multipedidos Logo">
                </a>
                
                <div class="footer-links">
                    <a [href]="footerLinkCta" target="_blank" rel="noopener" class="footer-cta"
                       data-cy="mpBannerCta" (click)="onFooterBannerClick('cta', $event)">
                        {{ footerLinkText }}
                    </a>
                </div>
            </div>
            
            <div class="footer-divider"></div>
            
            <div class="footer-bottom">
                <p class="company-name">© {{ getCurrentYear() }} Multipedidos Soluções de Software LTDA</p>
            </div>
        </div>
    </footer>
</div>